import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { M_CheckBox, M_Select } from "../../../../M_Components";
import { genericEntityService } from "src/services/genericEntityService";


const convertToDropdownOption = (arr) => {
    if (!arr){
        return [];
    }

    return arr.map(el => ({
            value: el.Id,
            label: el.DisplayName,
            Id: el.Id
        }))
}

export const ReferenceColumnForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const [rawReferenceEntities, setRawTables] = useState([]);

    const canChangeTable = useMemo(() => {
        return (canEdit && field?.fieldId === null) ?? false
    }, [canEdit, field]);

    const dropdownTables = useMemo(() => {
        return convertToDropdownOption(rawReferenceEntities);
    }, [rawReferenceEntities])

    const selectedTable = useMemo(() => {
        return (canChangeTable 
            ? dropdownTables?.find(t => t.Id === field.referenceTable)
            : dropdownTables?.find(t => t.Id === field.referenceTable)?.value) ?? ""
    }, [field.referenceTable, canChangeTable, dropdownTables])

    const dropdownColumns = useMemo(() => {
        if (!field.referenceTable){
            return [];
        }
        const rawColumns = rawReferenceEntities.find(e => e.Id === field.referenceTable);
        return convertToDropdownOption(rawColumns?.Columns);
    }, [rawReferenceEntities, field.referenceTable])

    const selectedColumns = useMemo(() => {
        let parsedIds = [];
        try {
            parsedIds = JSON.parse(field.referenceColumns) ?? [];
        } catch {
            parsedIds = [];
        }

        const columns = rawReferenceEntities?.find(t => t.Id === field.referenceTable)
            ?.Columns?.filter(c => parsedIds.includes(c.Id));

        const convertedColumns = convertToDropdownOption(columns); 
        return (canEdit
            ? convertedColumns 
            : convertedColumns.map(el => el.value)) ?? [];
    }, [field.referenceColumns, field.referenceTable, canEdit, rawReferenceEntities])


    useEffect(() => {
        genericEntityService.getReferenceEntities()
             .then(function (response) {
                setRawTables([
                    ...response.data
                ])
            })
    }, [])


    const handleReferenceTableChange = (event) => {
        propertyChangeCallback("referenceColumns", JSON.stringify([]));
        if (!event) {
            propertyChangeCallback("referenceTable", null);
            return;
        }
        
        propertyChangeCallback("referenceTable", event.Id);
    }

    const handleReferenceColumnChange = (event) => {
        const normalizedValue = event?.map(e => e.Id) ?? [];
        propertyChangeCallback("referenceColumns", JSON.stringify(normalizedValue));
    }

    const handleChange = (property, value) => propertyChangeCallback(property, value);

    return (
        <>
            <div className="field-two-columns">
                <M_Select
                    autocomplete={canChangeTable}
                    label={t("NgeTable")}
                    value={selectedTable}
                    options={dropdownTables}
                    noNone
                    required
                    disabled={!canChangeTable}
                    onChangeValue={handleReferenceTableChange}
                />
            </div>
            <div className="field-two-columns">
                <M_Select
                    autocomplete={canEdit}
                    multiple
                    label={t("NgeDisplayFields")}
                    value={selectedColumns}
                    options={dropdownColumns}
                    noNone
                    required
                    disabled={!canEdit}
                    onChangeValue={handleReferenceColumnChange}
                />   
            </div>
            <M_CheckBox
                className="field-one-columns"
                label={t("NgeAllowMultiple")}
                checked={field.allowMultiple ?? false}
                required
                disabled={!canEdit}
                onChange={(e) => handleChange("allowMultiple", e.target.checked)}
            />

        </>
    )
}